module.exports = __webpack_public_path__ + "img/mobile-clock-wallpaper.541355b0.jpg";